<!--
  * @name: abin
  * @description: 跳转下载中心弹窗
  * @date:2022-4-1
-->
<template>
  <!--  遮蔽层-->
  <transition name="bounce">
    <div class="ls-loading-down" v-show="dialog">
      <div class="down-content">
        <div class="header">
          <div v-if="IsSuccess" class="check"></div>
          <div v-else class="close"></div>
          <div class="tip">{{ tip }}</div>
          <div class="content">
            {{ content }}
          </div>
        </div>

        <div class="btn">
          <div class="closebtn" @click="cancelFun">关闭</div>
          <div style="clear: both"></div>
          <div class="sureBtn" @click="goToDownPage">
            {{ downloadBtn }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'LsDownLoad',
  props: {
    // 接口
    apiFun: {
      type: Function,
      default: function () {}
    },
    // 成功后显示内容
    successContent: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 失败后显示内容
    errorContent: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 按钮内容
    downloadBtn: {
      type: String,
      default: '打开下载列表'
    }
  },
  data () {
    return {
      dialog: false,
      content: '',
      IsSuccess: true,
      tip: ''
    }
  },
  methods: {
    /**
     * @description:  使用ref从外部打开弹窗
     */
    openModal (parmas) {
      const { tip: successTip, content: successContent } = this.successContent
      const { tip: errorTip, content: errorContent } = this.errorContent
      this.apiFun(parmas)
        .then((res) => {
          if (res.code === 200) {
            this.content = successContent || '报表生成需要一些时间，请耐心等候，同时您可以前往下载列表查看执行进度。'
            this.tip = successTip || '加入下载列表成功！'
            this.IsSuccess = true
          } else {
            this.tip = errorTip || '加入下载列表失败!'
            this.IsSuccess = false
            this.content = errorContent || res.msg || res.data.msg || '导出错误'
          }
          this.dialog = true
        })
        .catch((res) => {
          this.tip = errorTip || '加入下载列表失败!'
          this.IsSuccess = false
          this.content = errorContent || res.msg || res.data.msg || '导出错误'
          this.dialog = true
        })
    },
    /**
     * @name:
     * @description: 取消 关闭按钮
     */
    cancelFun () {
      this.dialog = false
    },
    /**
     * @name:
     * @description: 跳转到下载中心
     */
    goToDownPage () {
      this.cancelFun()
      this.$emit('closeDown')
      this.$router.push({ name: 'download' })
      this.dialog = false
    }
  }
}
</script>
<style lang="less" scoped>
.ls-loading-down {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: auto;
  outline: 0;
  background: rgba(0, 0, 0, 0.38);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.down-content {
  background-color: white;
  margin: 10% 20%;
  width: 400px;
  min-height: 200px;
  border-radius: 10px;
  .header {
    min-height: 148px;
  }
}
.tip {
  font-weight: bold;
  text-align: center;
  font-size: 18px;
}
.sureBtn {
  width: 200px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-align: center;
  color: #1790ff;
  font-size: 13px;
  border-left: 1px solid #f0f0f0;
  letter-spacing: 2px;
  font-weight: bold;
}
.title {
  font-size: 16px;
  padding: 4px 8px;
  font-weight: 500;
  color: black;
  margin-bottom: 4px;
  border-bottom: 1px solid #f0f0f0;
}
.btn {
  height: 48px;
  padding: 10px 0;
  display: flex;
}
.content {
  width: 280px;
  margin: 10px 50px;
  padding: 10px 20px;
  font-size: 13px;
  color: #999999;
  border-top: 1px solid #f0f0f0;
  letter-spacing: 2px;
  line-height: 20px;
}
.closebtn {
  width: 199px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #555555;
  font-size: 13px;
  letter-spacing: 2px;
  cursor: pointer;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  30% {
    opacity: 0.3;
  }
  40% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 0.6;
  }
  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}
.close {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 50px;
  background: red;
  border-radius: 50px;
  margin: -23px 175px 15px 175px;
  &:after {
    position: absolute;
    content: ' ';
    background-color: white;
    left: 10px;
    top: 22px;
    width: 60%;
    height: 10%;
    transform: rotate(-45deg);
  }
  &:before {
    position: absolute;
    content: ' ';
    background-color: white;
    left: 10px;
    top: 22px;
    width: 60%;
    height: 10%;

    transform: rotate(45deg);
  }
}
.check {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 50px;
  background: #1790ff;
  border-radius: 50px;
  margin: -23px 175px 15px 175px;
}
.check::after {
  content: '';
  position: absolute;
  left: 14px;
  top: 14px;
  width: 50%;
  height: 25%;
  border: 4px solid #ffffff;
  border-radius: 1px;
  border-top: none;
  border-right: none;
  background: transparent;
  transform: rotate(-45deg);
}
</style>
